import Statistics from "../../modules/Statistics/Statistics.jsx";

function PageStatistics() {
    return <><Statistics/></>
}

export default PageStatistics;
